import { WrapperPlatform } from '@/models/enum/wrapper-platform.enum';

// The Android app wrapper reports a non-zero env(safe-area-inset-bottom) even with the
// opaque 3-button navigation bar, so CSS scoped to html.android zeroes that inset (LP-1167).
export const syncAndroidWrapperClass = (root: HTMLElement, platform: WrapperPlatform): void => {
  root.classList.toggle('android', platform === WrapperPlatform.Android);
};
